<template>
    <div>
        <mavon-editor 
            v-model="content" 
            ref="md" 
            :subfield="prop.subfield"
            defaultOpen='preview'
            :toolbarsFlag="prop.toolbarsFlag"
            :editable="prop.editable"
            :scrollStyle="prop.scrollStyle"
            :toolbars='toolbars'
            style="max-height:calc( 100vh - 64px );min-height:calc( 100vh - 64px );width:100%;padding:5px;background-color:#DBE7F1"
        />
    </div>
</template>

<script>
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
    export default {
    // 注册
    components: {
        mavonEditor,
    },
    props: ['content'],
    data() {
        return {
            content:this.content, // 输入的markdown
            html:'',    // 及时转的html
        }
    },
    created () {
    },
    methods: {

    },
    mounted() {

    },
    computed: {
         prop () {
          let data = {
            subfield: false,// 单双栏模式
            editable: true,
            toolbarsFlag: false,
            scrollStyle: true
          }
          return data
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/my-components/previewMD.vue